import { message, Button, Form, InputNumber, Select } from "antd";
import { useEffect, useState } from "react";
import { useGlobalState } from "../../components/global";

export default function TongueConf() {
    const { jsonRequest } = useGlobalState();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        handleLoadData('TONGUE');
    }, []);

    const handleLoadData = async (checkType: string) => {
        setLoading(true);
        try {
            var response = await jsonRequest.get(`/back/other/check-times/${checkType}`, {});
            form.setFieldsValue({
                checkType: checkType,
                times: response?.body?.data?.times || 0,
                timesType: response?.body?.data?.timesType || 'DAY'
            });
        } catch (error) {
            console.error("加载数据失败:", error);
            form.setFieldsValue({
                checkType: checkType,
                times: 0,
                timesType: 'DAY'
            });
        } finally {
            setLoading(false);
        }
    }

    const handleSubmit = async (values: any) => {
        try {
            var result = await jsonRequest.post(`/back/other/check-times`, {
                checkType: values.checkType,
                times: values.times,
                timesType: values.timesType,
            }).then((resp: any) => resp.json());
            form.resetFields();
            if (result?.code !== 0) {
                message.error(result?.data?.msg || "保存失败");
                return;
            }
            handleLoadData(values.checkType);
            message.success("保存成功");
        } catch (error) {
            message.error("保存失败: " + (error as Error).message);
        }
    }

    // 处理checkType变化的回调
    const onCheckTypeChange = (value: string) => {
        handleLoadData(value);
    }

    return (
        <div>
            <h1>AI次数设置</h1>
            <div className="content" style={{ width: 600 }}>
                <Form form={form} name="TongueConfForm" className='tongue-conf-form' labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} onFinish={handleSubmit}>
                    <Form.Item name="checkType" label="项目" initialValue="TONGUE" rules={[{ required: true, message: '不能为空' }]}>
                        <Select
                            options={[
                                { label: "面诊", value: 'FACE' },
                                { label: "脉诊", value: 'PULSE' },
                                { label: "AI舌诊", value: 'TONGUE' },
                                { label: "体质检测", value: 'CORPOREALITY' },
                                { label: "食物识别", value: 'FOOD_RECOGNITION' },
                            ]}
                            onChange={onCheckTypeChange}
                        />
                    </Form.Item>
                    <Form.Item name="times" label="免费次数" rules={[{ required: true, message: '不能为空' }]}>
                        <InputNumber
                            style={{ width: '100%' }}
                            min={0}
                            placeholder="请输入免费次数"
                            addonAfter="次"
                        />
                    </Form.Item>
                    <Form.Item name="timesType" label="次数类型" initialValue="DAY" rules={[{ required: true, message: '不能为空' }]}>
                        <Select
                            options={[
                                { label: "每天", value: 'DAY' },
                                { label: "每年", value: 'YEAR' },
                                { label: "永远", value: 'FOREVER' },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Button type="primary" htmlType="submit" size="large" loading={loading}>
                            保存
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}
